export const PRODUCT_TOUR_OVERVIEW_OPENED = 'OverviewProductTourOpened'
export const PRODUCT_TOUR_OVERVIEW_COMPLETED = 'OverviewProductTourCompleted'
export const WHATS_NEW_OPENED_PREVIOUSLY = 'WhatsNewOpenedPreviously'
